module.exports = __webpack_public_path__ + "static/media/4.22a962b8.svg";